export const formatNumber = (
  number: number | bigint = 0,
  options?: Intl.NumberFormatOptions,
): string => {
  const nf = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    ...options,
  })
  return nf.format(number)
}

export const formatCurrency = (number: number | bigint = 0, currency = 'USD'): string => {
  const nf = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
  return nf.format(number)
}

export const formatPercentage = (
  number: number | bigint = 0,
  fractionDigits = 2,
): string => {
  const nf = new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  })
  return nf.format(Number(number)) // Divide by 100 to correctly format as percentage
}
